function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.date.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.array.sort.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.date.to-iso-string.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.set-prototype-of.js";
import "core-js/modules/es6.object.get-prototype-of.js";
import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.create.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.is-array.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.from.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* jshint esversion: 8 */
import { DateTimeFormatter } from './Helpers/DateTimeFormatter';
import { DropdownBuilder } from './Helpers/DropdownBuilder';
import { ErrorBuilder } from './Helpers/ErrorBuilder';
import { FormManager } from './Helpers/FormManager';
import { InnerPageBuilder } from './Helpers/InnerPageBuilder';
import { HouseholdApiService } from './Services/HouseholdApiService';
import { LookupApiService } from './Services/LookupApiService';
import { OAuthService } from './Services/OAuthService';
import { UserService } from './Services/UserService';
import { AddressAutoComplete } from './Shared/AddressAutoComplete';
import { ComponentBase } from './Shared/ComponentBase';
import { Configuration } from './Shared/Configuration';
import { DateTimeUtils } from './Shared/DateTimeUtils';
import { I18N } from './Shared/I18n';
export var MppHousehold = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppHousehold, _ComponentBase);

  var _super = _createSuper(MppHousehold);

  function MppHousehold() {
    var _this;

    _classCallCheck(this, MppHousehold);

    _this = _super.call(this);
    var config = new Configuration();
    _this._getLocalCountryCode = config.GetLocalCountryCode;
    _this._appRoot = config.GetAppRoot();
    _this._isHeadOfHousehold = false;
    _this._householdId = null;
    _this._addressAutoComplete = new AddressAutoComplete(_this._root);
    return _this;
  }

  _createClass(MppHousehold, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

      if (!!this._$householdWrapper) {
        this.loadAttributes();
        this.LoadHousehold(this.i18n);
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.hideAddHouseholdMember = this.getAttribute("hideaddhouseholdmember") || "false";
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppHousehold.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this2._root.innerHTML = "Unable to connect. Please check Permitted URLs.";
                  } else {
                    _this2._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                // Load attributes
                this.loadAttributes(); // Literals

                this.i18n = i18n;
                this._root.innerHTML = "\n\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\t\t\t<div class=\"mppw-component-container mpp-household\">\n\t\t\t\t<h1>").concat(i18n.header, "</h1>\n\t\t\t\t<div id=\"loginButtonContainer\" class=\"mppw-centered\" style=\"display: none;\"></div>\n\t\t\t\t<div id=\"emptyContainer\"></div>\n\t\t\t\t<div id=\"householdWrapper\" style=\"display: none;\"></div>\n\t\t\t</div>\n\t\t");
                this._locale = localStorage.userLocale || "en"; // Selectors

                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$householdWrapper = this._root.querySelector("#householdWrapper");
                this._$emptyContainer = this._root.querySelector("#emptyContainer"); // Templates

                this._$loginButtonContainer.innerHTML +=  `<div class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${i18n.loginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="${i18n.loginButton}"/>` ;
                this._$emptyContainer.innerHTML +=  `<i class="mppw-spinner"></i>` ;
                this._$householdWrapper.innerHTML +=  `<div class="mpp-household--header-container"><h2 id="householdName" class="mpp-household--header">${i18n.title}</h2><a class="mpp-household--header-wrapper" href="#" id="editHouseholdName" data-searchmode="0"><img class="mpp-icon--household" src="${this._appRoot}/Content/icons/icon-household-edit.svg"/> <span class="edit">${i18n.editLabel}</span></a></div><div id="householdAlertContainer"></div><div id="householdDetails"></div><form id="householdForm" class="mppw-form mppw-form-validate" style="display: none"><div class="mpp-household--form-body"><h3 class="mpp-household--form-header">${i18n.editContactInfo}</h3><div id="householdFormContainer"></div></div><div class="mppw-right mpp-household--form-footer"><div class="mppw-btn secondary" id="closeHousehold">${i18n.closeButton}</div><div class="mppw-btn primary" id="saveHousehold">${i18n.saveButton}</div></div></form><div class="mpp-household--header-container"><h2 class="mpp-household--header">${i18n.header}</h2><a class="mpp-household--header-wrapper" href="#" id="addNewMember" data-searchmode="0"><img class="mpp-icon--household" src="${this._appRoot}/Content/icons/icon-household-add-member.svg"/> <span class="edit">${i18n.addMemberLabel}</span></a></div><div id="householdMemberAlertContainer"></div><div id="householdMemberList" class="mppw-card--grid"></div><form id="householdMemberForm" class="mppw-form mppw-form-validate" style="display: none"><div class="mpp-household--form-body"><div id="householdMemberFormContainer"></div></div><div class="mppw-right mpp-household--form-footer"><div class="mppw-btn secondary" id="closeHouseholdMember">${i18n.closeButton}</div><div class="mppw-btn primary" id="saveHouseholdMember">${i18n.saveButton}</div></div></form>` ; // Dynamically Generated from Templates Selector

                this._$loginButton = this._root.querySelector("#loginButton");
                this._$householdName = this._root.querySelector('#householdName');
                this._$editHouseholdName = this._root.querySelector('#editHouseholdName');
                this._$householdDetails = this._root.querySelector('#householdDetails');
                this._$householdAlertContainer = this._root.querySelector('#householdAlertContainer');
                this._$householdForm = this._root.querySelector('#householdForm');
                this._$householdFormContainer = this._root.querySelector('#householdFormContainer');
                this._$householdSeasonalFormContainer = this._root.querySelector('#householdSeasonalFormContainer');
                this._$closeHousehold = this._root.querySelector('#closeHousehold');
                this._$saveHousehold = this._root.querySelector('#saveHousehold');
                this._$addNewMemberButton = this._root.querySelector('#addNewMember');
                this._$householdMemberList = this._root.querySelector('#householdMemberList');
                this._$householdMemberAlertContainer = this._root.querySelector('#householdMemberAlertContainer');
                this._$householdMemberForm = this._root.querySelector('#householdMemberForm');
                this._$householdMemberFormContainer = this._root.querySelector('#householdMemberFormContainer');
                this._$closeHouseholdMember = this._root.querySelector('#closeHouseholdMember');
                this._$saveHouseholdMember = this._root.querySelector('#saveHouseholdMember');
                this._$householdMemberMemberHeader = this._root.querySelector('#householdMemberMemberHeader'); // Services

                this._householdService = new HouseholdApiService();
                this._lookupService = new LookupApiService();
                UserService.GetCurrentUser().then(function (userInfo) {
                  _this2._$loginButtonContainer.style.display = "none";
                  _this2._$householdWrapper.style.display = "";

                  _this2.LoadHousehold(i18n);
                }, function () {
                  _this2._$emptyContainer.innerHTML = "";
                  _this2._$householdWrapper.style.display = "none";
                  _this2._$loginButtonContainer.style.display = "";
                }); //this.BuildHouseholdMemberForm('', i18n);
                // Wire-up event listeners:

                this.BindEventListeners();

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this3 = this;

      // Event
      this._$loginButton.addEventListener("click", function () {
        OAuthService.SignIn();
      }); // Open Household to Edit


      this._$editHouseholdName.addEventListener("click", function (e) {
        e.preventDefault();
        _this3._$householdAlertContainer.innerHTML = '';

        var searchMode = _this3._$editHouseholdName.getAttribute("data-searchmode");

        if (searchMode === "0") {
          _this3.ShowHouseholdForm();
        } else {
          _this3.CloseOrCancelHouseholdForm();
        }
      }); // Close or Cancel Household form


      this._$closeHousehold.addEventListener("click", function (e) {
        e.preventDefault();
        _this3._$householdAlertContainer.innerHTML = '';

        _this3.CloseOrCancelHouseholdForm();
      });

      var householdForm = new FormManager(this._$householdForm);

      this._$saveHouseholdMember.addEventListener("click", function (e) {
        if (householdMemberForm.IsValid()) {
          var formData = new FormData(_this3._$householdMemberForm);

          _this3.AddCommunicationPreferencesToFormData(formData);

          _this3.AddDisplayNameToFormData(formData);

          _this3.AddHouseholdIdToFormData(formData);

          var isExistingContact = parseInt(formData.get("contactId")) > 0;

          _this3._householdService.UpdateHouseholdMember(formData).then(function (membersResponse) {
            _this3._$householdAlertContainer.innerHTML = '';

            if (!!isExistingContact) {
              ErrorBuilder.RenderAlert(_this3._$householdMemberAlertContainer, 'success', _this3.i18n.thankYouUpdateMember);
            } else {
              ErrorBuilder.RenderAlert(_this3._$householdMemberAlertContainer, 'success', _this3.i18n.thankYouAddMember);
            }

            householdMemberForm.Reset();

            _this3.CloseOrCancelHouseholdMemberForm();

            _this3.BuildHouseholdMemberCards(membersResponse);
          })["catch"](ErrorBuilder.RenderHandler(_this3._$householdMemberAlertContainer, _this3.i18n));
        } else {
          ErrorBuilder.RenderAlert(_this3._$householdMemberAlertContainer, 'warning', 'Please complete household member form!');
        }
      });

      this._$saveHousehold.addEventListener("click", function (e) {
        if (householdForm.IsValid()) {
          var formData = new FormData(_this3._$householdForm);

          _this3.AddRepeatAnnuallyToFormData(formData);

          _this3.AddHouseholdUnlistedToFormData(formData);

          _this3._householdService.UpdateHousehold(formData).then(function (householdResponse) {
            _this3._$householdMemberAlertContainer.innerHTML = '';
            householdForm.Reset();
            ErrorBuilder.RenderAlert(_this3._$householdAlertContainer, 'success', _this3.i18n.thankYouUpdateMember);

            _this3.CloseOrCancelHouseholdForm();

            _this3.BuildHouseholdDetails(householdResponse);

            _this3.BuildHouseholdForm(householdResponse, _this3.i18n);
          })["catch"](ErrorBuilder.RenderHandler(_this3._$householdMemberAlertContainer, _this3.i18n));
        } else {
          ErrorBuilder.RenderAlert(_this3._$householdAlertContainer, 'warning', _this3.i18n.completeHouseholdForm);
        }
      }); // Household Form Edit Submit


      this._$householdForm.addEventListener("submit", function (e) {
        e.preventDefault();
        return;
      });

      var householdMemberForm = new FormManager(this._$householdMemberForm); // Open Household Member Form

      this._$addNewMemberButton.addEventListener("click", function (e) {
        e.preventDefault();
        _this3._$householdMemberAlertContainer.innerHTML = '';

        var searchMode = _this3._$addNewMemberButton.getAttribute("data-searchmode");

        _this3.BuildHouseholdMemberForm('', _this3.i18n);

        if (searchMode === "0") {
          _this3.ShowHouseholdMemberForm();
        } else {
          _this3.CloseOrCancelHouseholdMemberForm();
        }
      }); // Household Member Form Edit Submit
      // if contactId = 0 new member if contactId != 0 update member


      this._$householdMemberForm.addEventListener("submit", function (e) {
        e.preventDefault();
        return;
      }); // Close or Cancel Household Member Form


      this._$closeHouseholdMember.addEventListener("click", function (e) {
        e.preventDefault();
        _this3._$householdMemberAlertContainer.innerHTML = '';
        householdMemberForm.Reset();

        _this3.CloseOrCancelHouseholdMemberForm();
      });
    }
  }, {
    key: "AddHouseholdUnlistedToFormData",
    value: function AddHouseholdUnlistedToFormData(formData) {
      formData.set('homePhoneUnlisted', formData.get('homePhoneUnlisted') == "on");
      formData.set('homeAddressUnlisted', formData.get('homeAddressUnlisted') == "on");
    }
  }, {
    key: "AddRepeatAnnuallyToFormData",
    value: function AddRepeatAnnuallyToFormData(formData) {
      if (!!formData.get('alternativeAddressRepeatAnnually')) {
        formData.set('alternativeAddressRepeatAnnually', 'true');
      }
    }
  }, {
    key: "AddHouseholdIdToFormData",
    value: function AddHouseholdIdToFormData(formData) {
      if (formData.get('householdId') === '') {
        formData.set('householdId', "".concat(this._householdId));
      }
    }
  }, {
    key: "AddDisplayNameToFormData",
    value: function AddDisplayNameToFormData(formData) {
      var lastName = formData.get('lastName');
      var nickName = formData.get('nickName');
      var firstName = formData.get('firstName');
      formData.set('displayName', "".concat(lastName, ", ").concat(nickName || firstName));

      if (!!formData.get('suffixId')) {
        var suffixId = parseInt(formData.get('suffixId'));

        var suffixName = _toConsumableArray(this._root.querySelector('#suffixId').options).sort(function (a, b) {
          return a.value - b.value;
        })[suffixId].text;

        var displayName = formData.get('displayName');
        formData.set('displayName', displayName + " ".concat(suffixName));
      }
    }
  }, {
    key: "AddCommunicationPreferencesToFormData",
    value: function AddCommunicationPreferencesToFormData(formData) {
      formData.set('removeFromDirectory', formData.get('removeFromDirectory') == "on");
      formData.set('emailUnlisted', formData.get('emailUnlisted') == "on");
      formData.set('mobilePhoneUnlisted', formData.get('mobilePhoneUnlisted') == "on");
      formData.set('doNotText', formData.get('doNotText') == "on");
      formData.set('bulkEmailOptOut', formData.get('bulkEmailOptOut') == "on");
    }
  }, {
    key: "LoadHousehold",
    value: function LoadHousehold() {
      var _this4 = this;

      var i18n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.i18n;
      // variables used in household-card.html
      var APP_ROOT = this._appRoot;

      this._householdService.GetHousehold().then(function (data) {
        _this4._$emptyContainer.innerHTML = "";
        _this4._$householdWrapper.style = ""; // if (this._isHeadOfHousehold) {

        _this4.BuildHouseholdForm(data, i18n); // }


        var name = data.name,
            address = data.address,
            alternativeAddress = data.alternativeAddress,
            familyMembers = data.familyMembers,
            congregationName = data.congregationName,
            congregationId = data.congregationId;
        _this4._$householdName.innerHTML = name;

        _this4.BuildHouseholdDetails(data);

        _this4.VerifyHeadOfHousehold().then(function () {
          _this4.BuildHouseholdMemberCards(familyMembers);
        });
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderHandler(_this4._$emptyContainer);
        _this4._$emptyContainer.innerHTML = "";
        _this4._$householdWrapper.style.display = "none";
        _this4._$loginButtonContainer.style.display = "";
      });
    }
  }, {
    key: "VerifyHeadOfHousehold",
    value: function VerifyHeadOfHousehold() {
      var _this5 = this;

      // remove add household member button based on config
      this._$addNewMemberButton.style.display = this.hideAddHouseholdMember === "true" ? "none" : 'flex';
      return UserService.GetCurrentUser().then(function (userInfo) {
        if (!!userInfo) {
          _this5.userInfo = userInfo;
          _this5._householdId = _this5.userInfo.householdId;

          if (_this5.userInfo && _this5.userInfo.isHeadOfHousehold) {
            _this5._isHeadOfHousehold = _this5.userInfo.isHeadOfHousehold;
          }

          if (!_this5._isHeadOfHousehold) {
            _this5._$editHouseholdName.setAttribute("disabled", "");

            _this5._$addNewMemberButton.setAttribute("disabled", "");
          }
        }
      });
    }
  }, {
    key: "BuildHouseholdDetails",
    value: function BuildHouseholdDetails(householdResponse) {
      var address = householdResponse.address,
          alternativeAddress = householdResponse.alternativeAddress,
          congregationName = householdResponse.congregationName,
          alternativeAddressRepeatAnnually = householdResponse.alternativeAddressRepeatAnnually,
          alternativeAddressStart = householdResponse.alternativeAddressStart,
          alternativeAddressEnd = householdResponse.alternativeAddressEnd;
      var country,
          addressLine1,
          addressLine2,
          city,
          stateRegion,
          postalCode = '';

      if (address !== null) {
        country = address.country;
        addressLine1 = address.addressLine1;
        addressLine2 = address.addressLine2;
        city = address.city;
        stateRegion = address.stateRegion;
        postalCode = address.postalCode;
      }

      var altCountry,
          altAddressLine1,
          altAddressLine2,
          altCity,
          altStateRegion,
          altPostalCode = '';

      if (alternativeAddress !== null) {
        altCountry = alternativeAddress.country;
        altAddressLine1 = alternativeAddress.addressLine1;
        altAddressLine2 = alternativeAddress.addressLine2;
        altCity = alternativeAddress.city;
        altStateRegion = alternativeAddress.stateRegion;
        altPostalCode = alternativeAddress.postalCode;
      }

      var isAltAddressInPast = !alternativeAddressRepeatAnnually && new Date(alternativeAddressEnd) < new Date();
      var isAltAddressInFuture = alternativeAddressRepeatAnnually || new Date(alternativeAddressStart) > new Date() || new Date(alternativeAddressEnd) > new Date();
      var validAlternativeAddress = !!alternativeAddress && !isAltAddressInPast && isAltAddressInFuture;
      var altAddressDateRange = '';

      if (alternativeAddressRepeatAnnually) {
        altAddressDateRange = "".concat(new DateTimeFormatter().ToShortDayMonthOnlyRange(alternativeAddressStart, alternativeAddressEnd), " annually");
      } else {
        altAddressDateRange = "".concat(new DateTimeFormatter().ToShortDateRange(alternativeAddressStart, alternativeAddressEnd));
      }

      this._$householdDetails.innerHTML = InnerPageBuilder.BuildInnerPageDetails(!!congregationName ? InnerPageBuilder.BuildLabels([congregationName]) : '', !!address ? InnerPageBuilder.BuildAddress([country, addressLine1, addressLine2, "".concat(city || '', ", ").concat(stateRegion || '', " ").concat(postalCode || '')], this.i18n.primaryAddressLabel) : '', validAlternativeAddress ? InnerPageBuilder.BuildAddress([altCountry, altAddressLine1, altAddressLine2, "".concat(altCity || '', ", ").concat(altStateRegion || '', " ").concat(altPostalCode || ''), altAddressDateRange], this.i18n.alternativeAddressLabel) : '');
    }
  }, {
    key: "BuildHouseholdMemberCards",
    value: function BuildHouseholdMemberCards(familyMembers) {
      var _this6 = this;

      var householdMemberListHTML = '';

      if (familyMembers.length) {
        var _iterator = _createForOfIteratorHelper(familyMembers),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var member = _step.value;
            // variables used in household-card.html
            var contactId = member.contactId,
                displayName = member.displayName,
                firstName = member.firstName,
                nickName = member.nickName,
                lastName = member.lastName,
                imageUrl = member.imageUrl,
                householdPositionId = member.householdPositionId,
                householdPositionName = member.householdPositionName,
                dateOfBirth = member.dateOfBirth;
            var dateOfBirthText = ''; // Manually resolving date issue in DateTimeFormatter.js file

            if (dateOfBirth) {
              var newDate = DateTimeUtils.ParseAsLocalDateTime(dateOfBirth);
              var shortOptions = {
                weekday: 'short',
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              };
              dateOfBirthText = newDate.toLocaleDateString('en', shortOptions).slice(5);
            }

            var IMAGE_URL_SRC = !!imageUrl ? imageUrl : "".concat(this._appRoot, "/Content/icons/icon-household-member.svg");
            householdMemberListHTML +=  `<div class="mpp-card mpp-card--household" id="${contactId}" data-position="${householdPositionId}"><div class="mpp-card--household-body"><img class="${!!imageUrl ? 'mpp-card--household-image' : 'mpp-card--household-placeholder'}" src="${IMAGE_URL_SRC}"/><div class="mpp-card--household-text-wrapper"><h3 class="mpp-card--household-title">${!!lastName && (!!nickName || !!firstName) ? `${nickName || firstName} ${lastName}` : `${displayName}`}</h3><p>${householdPositionId ? householdPositionName : ''}</p><p>${dateOfBirthText}</p></div></div><div class="mpp-card--household-footer"><a class="mppw-btn primary mpp-card--edit-household-btn" data-contactid="${contactId}">${this.i18n.editMemberLabel}</a></div></div>` ;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        this._$householdMemberList.innerHTML = "<div id=\"familyMembersEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t<span class=\"mppw-alert__text\">No additional household members found</span>\n\t\t\t</div>";
      }

      this._$householdMemberList.innerHTML = householdMemberListHTML;
      this._$editHouseholdMemberButtons = this._$householdMemberList.querySelectorAll('.mpp-card--edit-household-btn');

      var _iterator2 = _createForOfIteratorHelper(this._$editHouseholdMemberButtons),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var editHouseholdMemberBtn = _step2.value;

          if (this._isHeadOfHousehold) {
            editHouseholdMemberBtn.addEventListener("click", function (e) {
              e.preventDefault();
              var contactId = e.target.dataset.contactid;

              _this6._$addNewMemberButton.click();

              var householdMember = familyMembers.find(function (x) {
                return x.contactId.toString() === contactId;
              });

              _this6.BuildHouseholdMemberForm(householdMember, _this6.i18n);

              var firstName = householdMember.firstName,
                  nickName = householdMember.nickName,
                  lastName = householdMember.lastName,
                  displayName = householdMember.displayName;

              if (nickName !== '') {
                _this6._root.querySelector('#householdMemberHeader').innerHTML = "".concat(_this6.i18n.editLabel, " ").concat(!!lastName && !!nickName ? "".concat(nickName, " ").concat(lastName) : "".concat(displayName));
              } else {
                _this6._root.querySelector('#householdMemberHeader').innerHTML = "".concat(_this6.i18n.editLabel, " ").concat(!!lastName && !!firstName ? "".concat(firstName, " ").concat(lastName) : "".concat(displayName));
              }
            });
          } else {
            editHouseholdMemberBtn.setAttribute('disabled', '');
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "ShowHouseholdForm",
    value: function ShowHouseholdForm() {
      this._$householdForm.style.display = "block";
      this._$householdDetails.style.display = "none";
      this._$householdMemberForm.style.display = "none";
      this._$householdMemberList.style.display = "none";

      this._$editHouseholdName.setAttribute("data-searchmode", "1");

      this._$addNewMemberButton.setAttribute("disabled", "");

      this._$editHouseholdName.setAttribute("disabled", "");
    }
  }, {
    key: "CloseOrCancelHouseholdForm",
    value: function CloseOrCancelHouseholdForm() {
      this._$householdForm.style.display = "none";
      this._$householdDetails.style.display = "block";
      this._$householdMemberList.style.display = "grid";

      this._$editHouseholdName.setAttribute("data-searchmode", "0");

      this._$addNewMemberButton.removeAttribute("disabled");

      this._$editHouseholdName.removeAttribute("disabled");
    }
  }, {
    key: "ShowHouseholdMemberForm",
    value: function ShowHouseholdMemberForm() {
      this._$householdMemberForm.style.display = "block";
      this._$householdMemberList.style.display = "none";

      this._$addNewMemberButton.setAttribute("data-searchmode", "1");

      this._$addNewMemberButton.setAttribute("disabled", "");

      this._$editHouseholdName.setAttribute("disabled", "");

      if (this._$addNewMemberButton.text.includes(this.i18n.addMemberLabel)) {
        this._root.querySelector('#householdMemberHeader').innerHTML = this.i18n.addMemberLabel;
      }
    }
  }, {
    key: "CloseOrCancelHouseholdMemberForm",
    value: function CloseOrCancelHouseholdMemberForm() {
      this._$householdMemberForm.style.display = "none";
      this._$householdMemberList.style.display = "grid";

      this._$addNewMemberButton.setAttribute("data-searchmode", "0");

      this._$addNewMemberButton.removeAttribute("disabled");

      this._$editHouseholdName.removeAttribute("disabled");
    }
  }, {
    key: "BuildHouseholdForm",
    value: function BuildHouseholdForm(householdData, i18n) {
      var _this7 = this;

      if (householdData === undefined) return; // variables used in household-form.html

      var householdId = householdData.householdId,
          name = householdData.name,
          homePhone = householdData.homePhone,
          congregationId = householdData.congregationId,
          congregationName = householdData.congregationName,
          address = householdData.address,
          alternativeAddress = householdData.alternativeAddress,
          alternativeAddressStart = householdData.alternativeAddressStart,
          alternativeAddressEnd = householdData.alternativeAddressEnd,
          alternativeAddressRepeatAnnually = householdData.alternativeAddressRepeatAnnually,
          homePhoneUnlisted = householdData.homePhoneUnlisted,
          homeAddressUnlisted = householdData.homeAddressUnlisted; // Build Household Form

      var HOMEPHONE_VALUE = homePhone || '';
      var ADDRESSID_VALUE = address && address.addressId || '';
      var COUNTRY_VALUE = address && address.countryCode || '';
      var ADDRESS1_VALUE = address && address.addressLine1 || '';
      var ADDRESS2_VALUE = address && address.addressLine2 || '';
      var CITY_VALUE = address && address.city || '';
      var STATE_VALUE = address && address.stateRegion || '';
      var ZIP_VALUE = address && address.postalCode || '';
      var ALTERNATIVE_START_VALUE = alternativeAddressStart && alternativeAddressStart.slice(0, 10) || '';
      var ALTERNATIVE_END_VALUE = alternativeAddressEnd && alternativeAddressEnd.slice(0, 10) || '';
      var ALTERNATIVE_ADDRESSID_VALUE = alternativeAddress && alternativeAddress.addressId || '';
      var ALTERNATIVE_COUNTRY_VALUE = alternativeAddress && alternativeAddress.countryCode || '';
      var ALTERNATIVE_ADDRESS1_VALUE = alternativeAddress && alternativeAddress.addressLine1 || '';
      var ALTERNATIVE_ADDRESS2_VALUE = alternativeAddress && alternativeAddress.addressLine2 || '';
      var ALTERNATIVE_CITY_VALUE = alternativeAddress && alternativeAddress.city || '';
      var ALTERNATIVE_STATE_VALUE = alternativeAddress && alternativeAddress.stateRegion || '';
      var ALTERNATIVE_ZIP_VALUE = alternativeAddress && alternativeAddress.postalCode || '';
      this._$householdFormContainer.innerHTML =  `<div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><select id="congregationId" name="congregationId" class="mppw-form-field__control" value="${congregationId}"></select> <label class="mppw-form-field__label">${i18n.congregationLabel}</label></div></div><div class="mppw-form-field mpp-toggle"><input class="toggle--input" id="homePhoneUnlisted" name="homePhoneUnlisted" type="checkbox"/> <label class="toggle--label" for="homePhoneUnlisted"></label> <label class="mppw-form-field__label">${i18n.homePhoneUnlistedLabel}</label> <span class="mpp-toggle--label">${i18n.homePhoneUnlistedLabel}</span></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><input type="tel" id="homePhone" name="homePhone" class="mppw-form-field__control" value="${HOMEPHONE_VALUE}" maxlength="50"> <label class="mppw-form-field__label" for="homePhone">${i18n.homePhoneLabel}:</label></div></div><h3 class="mpp-household--form-header">${i18n.primaryAddressLabel}</h3><input type="hidden" name="HouseholdId" value="${householdId}"/> <input type="hidden" name="name" value="${name}"/> <input type="hidden" name="address.addressId" value="${ADDRESSID_VALUE}"/><div class="mppw-form-field mpp-toggle"><input class="toggle--input" id="homeAddressUnlisted" name="homeAddressUnlisted" type="checkbox"/> <label class="toggle--label" for="homeAddressUnlisted"></label> <label class="mppw-form-field__label">${i18n.homeAddressUnlistedLabel}</label> <span class="mpp-toggle--label">${i18n.homeAddressUnlistedLabel}</span></div><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="addressLine1" name="address.addressLine1" class="mppw-form-field__control" value="${ADDRESS1_VALUE}" autocomplete="off"> <label class="mppw-form-field__label" for="addressLine1">${i18n.addressLineLabel} 1:</label></div><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="addressLine2" name="address.addressLine2" class="mppw-form-field__control" value="${ADDRESS2_VALUE}"> <label class="mppw-form-field__label" for="addressLine2">${i18n.addressLineLabel} 2:</label></div><div class="mpp-household--form-row"><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="city" name="address.city" class="mppw-form-field__control" value="${CITY_VALUE}"> <label class="mppw-form-field__label" for="city">${i18n.cityLabel}:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="stateRegion" name="address.stateRegion" class="mppw-form-field__control" value="${STATE_VALUE}"> <label class="mppw-form-field__label" for="stateRegion">${i18n.stateLabel}:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="postalCode" name="address.postalCode" class="mppw-form-field__control" value="${ZIP_VALUE}"> <label class="mppw-form-field__label" for="postalCode">${i18n.postalCodeLabel}:</label></div></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><select id="country" name="address.countryCode" class="mppw-form-field__control" value="${COUNTRY_VALUE}"></select> <label class="mppw-form-field__label" for="country">${i18n.countryLabel}</label></div></div><h3 class="mpp-household--form-header">${i18n.seasonalAddressLabel}</h3><div class="mppw-form-field mpp-toggle"><input class="toggle--input" id="alternativeAddressRepeatAnnually" name="alternativeAddressRepeatAnnually" type="checkbox"/> <label class="toggle--label" for="alternativeAddressRepeatAnnually"></label> <label class="mppw-form-field__label">${i18n.repeatAnnuallyLabel}</label> <span class="mpp-toggle--label">${i18n.repeatAnnuallyLabel}</span></div><input type="hidden" name="alternativeAddress.addressId" value="${ALTERNATIVE_ADDRESSID_VALUE}"/><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><input type="date" id="alternativeAddressStart" name="alternativeAddressStart" class="mppw-form-field__control mppw-input-date" value="${ALTERNATIVE_START_VALUE}" data-invalid-message="" min="1900-01-01" max=""> <label class="mppw-form-field__label" for="alternativeAddressStart">${i18n.seasonalStartDateLabel}:</label></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><input type="date" id="alternativeAddressEnd" name="alternativeAddressEnd" class="mppw-form-field__control mppw-input-date" value="${ALTERNATIVE_END_VALUE}" data-invalid-message="" min="1900-01-01" max=""> <label class="mppw-form-field__label" for="alternativeAddressEnd">${i18n.seasonalEndDateLabel}:</label></div></div><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="alt_addressLine1" name="alternativeAddress.addressLine1" class="mppw-form-field__control" value="${ALTERNATIVE_ADDRESS1_VALUE}"> <label class="mppw-form-field__label" for="alt_addressLine1">${i18n.addressLineLabel} 1:</label></div><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="alt_addressLine2" name="alternativeAddress.addressLine2" class="mppw-form-field__control" value="${ALTERNATIVE_ADDRESS2_VALUE}"> <label class="mppw-form-field__label" for="alt_addressLine2">${i18n.addressLineLabel} 2:</label></div><div class="mpp-household--form-row"><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="alt_city" name="alternativeAddress.city" class="mppw-form-field__control" value="${ALTERNATIVE_CITY_VALUE}"> <label class="mppw-form-field__label" for="alt_city">${i18n.cityLabel}:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="alt_stateRegion" name="alternativeAddress.stateRegion" class="mppw-form-field__control" value="${ALTERNATIVE_STATE_VALUE}"> <label class="mppw-form-field__label" for="alt_stateRegion">${i18n.stateLabel}:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="alt_postalCode" name="alternativeAddress.postalCode" class="mppw-form-field__control" value="${ALTERNATIVE_ZIP_VALUE}"> <label class="mppw-form-field__label" for="alt_postalCode">${i18n.postalCodeLabel}:</label></div></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><select id="alt_country" name="alternativeAddress.countryCode" class="mppw-form-field__control" value="${ALTERNATIVE_COUNTRY_VALUE}"></select> <label class="mppw-form-field__label" for="alt_country">${i18n.countryLabel}</label></div></div>` ;
      new FormManager(this._$householdForm);
      this.RepeatAnnuallyHandler(alternativeAddressRepeatAnnually);
      this.HouseholdUnlistedHandler(homePhoneUnlisted, homeAddressUnlisted);
      this.PopulateHouseholdSelectOptions(COUNTRY_VALUE, ALTERNATIVE_COUNTRY_VALUE, congregationId, congregationName); // Attach Google Maps API

      var applyAddress = function applyAddress(address, prefix) {
        if (!!address) {
          var _addressLine1Element = _this7._$householdFormContainer.querySelector("#".concat(prefix, "addressLine1"));

          _addressLine1Element.value = address.addressLine1 || "";

          var addressLine2Element = _this7._$householdFormContainer.querySelector("#".concat(prefix, "addressLine2"));

          addressLine2Element.value = "";

          var cityElement = _this7._$householdFormContainer.querySelector("#".concat(prefix, "city"));

          cityElement.value = address.city || "";

          var stateRegionElement = _this7._$householdFormContainer.querySelector("#".concat(prefix, "stateRegion"));

          stateRegionElement.value = address.state || "";

          var postalCodeElement = _this7._$householdFormContainer.querySelector("#".concat(prefix, "postalCode"));

          postalCodeElement.value = address.postalCode || "";

          var countryElement = _this7._$householdFormContainer.querySelector("#".concat(prefix, "country"));

          for (var idx in countryElement.options) {
            var option = countryElement.options[idx];

            if (option.innerHTML == address.country) {
              countryElement.value = option.value;
              break;
            }
          }
        }
      };

      var addressLine1Element = this._$householdFormContainer.querySelector("#addressLine1");

      this._addressAutoComplete.attach(addressLine1Element, function (address) {
        applyAddress(address, "");
      });

      addressLine1Element = this._$householdFormContainer.querySelector("#alt_addressLine1");

      this._addressAutoComplete.attach(addressLine1Element, function (address) {
        applyAddress(address, "alt_");
      });
    }
  }, {
    key: "BuildHouseholdMemberForm",
    value: function BuildHouseholdMemberForm() {
      var member = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var i18n = arguments.length > 1 ? arguments[1] : undefined;
      var householdMember = {
        contactId: 0,
        householdId: '',
        imageUrl: '',
        firstName: '',
        middleName: '',
        lastName: '',
        nickName: '',
        displayName: '',
        genderId: '',
        dateOfBirth: '',
        maritalStatusId: '',
        emailAddress: '',
        mobilePhoneNumber: '',
        workPhoneNumber: '',
        homePhoneNumber: '',
        householdPositionId: '',
        suffixId: '',
        suffixName: '',
        prefixId: '',
        emailUnlisted: false,
        mobilePhoneUnlisted: false,
        doNotText: false,
        bulkEmailOptOut: false,
        removeFromDirectory: false
      };

      if (member !== '') {
        var contactId = member.contactId,
            householdId = member.householdId,
            firstName = member.firstName,
            lastName = member.lastName,
            middleName = member.middleName,
            nickName = member.nickName,
            displayName = member.displayName,
            genderId = member.genderId,
            maritalStatusId = member.maritalStatusId,
            imageUrl = member.imageUrl,
            householdPositionId = member.householdPositionId,
            suffixName = member.suffixName,
            suffixId = member.suffixId,
            prefixId = member.prefixId,
            dateOfBirth = member.dateOfBirth,
            emailAddress = member.emailAddress,
            mobilePhoneNumber = member.mobilePhoneNumber,
            workPhoneNumber = member.workPhoneNumber,
            homePhoneNumber = member.homePhoneNumber,
            emailUnlisted = member.emailUnlisted,
            mobilePhoneUnlisted = member.mobilePhoneUnlisted,
            doNotText = member.doNotText,
            bulkEmailOptOut = member.bulkEmailOptOut,
            removeFromDirectory = member.removeFromDirectory;
        householdMember = {
          contactId: contactId || 0,
          householdId: householdId || 0,
          imageUrl: imageUrl || '',
          firstName: firstName || '',
          middleName: middleName || '',
          lastName: lastName || '',
          nickName: nickName || '',
          displayName: displayName || '',
          genderId: genderId || null,
          dateOfBirth: dateOfBirth && dateOfBirth.slice(0, 10) || '',
          maritalStatusId: maritalStatusId || null,
          emailAddress: emailAddress || '',
          mobilePhoneNumber: mobilePhoneNumber || '',
          workPhoneNumber: workPhoneNumber || '',
          homePhoneNumber: homePhoneNumber || '',
          householdPositionId: householdPositionId || null,
          suffixName: suffixName || '',
          suffixId: suffixId || null,
          prefixId: prefixId || null,
          emailUnlisted: emailUnlisted || false,
          mobilePhoneUnlisted: mobilePhoneUnlisted || false,
          doNotText: doNotText || false,
          bulkEmailOptOut: bulkEmailOptOut || false,
          removeFromDirectory: removeFromDirectory || false
        };
      }

      var IMAGE_URL_SRC = !!householdMember.imageUrl ? householdMember.imageUrl : "".concat(this._appRoot, "/Content/icons/icon-household-member.svg");
      var IMAGE_URL_LABEL = !!householdMember.imageUrl ? i18n.changePhotoLabel : i18n.addPhotoLabel;
      var today = new Date().toISOString().split('T')[0];
      var isAddMemberOperation = householdMember.contactId > 0;
      this._$householdMemberFormContainer.innerHTML =  `<h3 class="mpp-household--form-header" id="householdMemberHeader">${isAddMemberOperation ? i18n.addMemberLabel : i18n.editMemberLabel}</h3><h4 class="mpp-household--form-subheader">${i18n.householdMemberSubheader}</h4><div class="mpp-household--header-wrapper"><img class="${!!householdMember.imageUrl ? 'mpp-card--household-image' : 'mpp-card--household-placeholder'}" id="householdImagePreview" src="${IMAGE_URL_SRC}"/><div class="mppw-form-field mppw-form-field--file"><input type="file" class="hidden" id="imageUrl" name="image" accept="image/*"/> <label for="imageUrl" class="edit" id="imageUrlLabel"><img class="mpp-icon--household" src="${this._appRoot}/Content/icons/icon-household-photo.svg"/>${IMAGE_URL_LABEL}</label></div></div><div id="fileTooLarge" class="mppw-alert mppw-alert__danger" style="display:none"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${i18n.uploadPhotoWarningMessage}</span></div><div id="householdMemberFormContainer"><h3 class="mpp-household--form-header">${i18n.personalLabel}</h3><input type="hidden" name="contactId" value="${householdMember.contactId}"/> <input type="hidden" name="householdId" value="${householdMember.householdId}"/><div class="mpp-household--form-row"><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><select id="prefixId" name="prefixId" class="mppw-form-field__control" value="${householdMember.prefixId}"></select> <label class="mppw-form-field__label">${i18n.prefixLabel}</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field"><input type="text" id="firstName" name="firstName" class="mppw-form-field__control" value="${householdMember.firstName}" required="" data-required-message="First Name is required please"> <label class="mppw-form-field__label" for="firstName">${i18n.firstNameLabel}*:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field"><input type="text" id="nickName" name="nickName" class="mppw-form-field__control" value="${householdMember.nickName}"> <label class="mppw-form-field__label" for="nickName">${i18n.nicknameLabel}:</label></div></div></div><div class="mpp-household--form-row"><div class="mpp-household--form-column"><div class="mppw-form-field"><input type="text" id="lastName" name="lastName" class="mppw-form-field__control" value="${householdMember.lastName}" required="" data-required-message="Last Name is required please"> <label class="mppw-form-field__label" for="lastName">${i18n.lastNameLabel}*:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field"><input type="text" id="middleName" name="middleName" class="mppw-form-field__control" value="${householdMember.middleName}"> <label class="mppw-form-field__label" for="middleName">${i18n.middleNameLabel}:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field mppw-form-field__static-container"><select id="suffixId" name="suffixId" class="mppw-form-field__control" value="${householdMember.suffixId}"></select> <label class="mppw-form-field__label">${i18n.suffixLabel}</label></div></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><select id="genderId" name="genderId" class="mppw-form-field__control" value="${householdMember.genderId}"></select> <label class="mppw-form-field__label">${i18n.genderLabel}</label></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field"><input type="date" id="dateOfBirth" name="dateOfBirth" class="mppw-form-field__control mppw-input-date" value="${householdMember.dateOfBirth}" data-invalid-message="" min="1900-01-01" max="${today}"> <label class="mppw-form-field__label" for="dateOfBirth">${i18n.dateOfBirthLabel}:</label></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><select id="maritalStatusId" name="maritalStatusId" class="mppw-form-field__control" value="${householdMember.maritalStatusId}"></select> <label class="mppw-form-field__label">${i18n.maritalStatusLabel}</label></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field"><input type="email" id="emailAddress" name="emailAddress" class="mppw-form-field__control" value="${householdMember.emailAddress}"> <label class="mppw-form-field__label" for="emailAddress">${i18n.emailLabel}:</label></div></div><div class="mpp-household--form-row"><div class="mpp-household--form-column"><div class="mppw-form-field"><input type="tel" id="mobilePhoneNumber" name="mobilePhoneNumber" class="mppw-form-field__control" value="${householdMember.mobilePhoneNumber}" maxlength="50"> <label class="mppw-form-field__label" for="mobilePhoneNumber">${i18n.mobilePhoneLabel}:</label></div></div><div class="mpp-household--form-column"><div class="mppw-form-field"><input type="tel" id="workPhoneNumber" name="workPhoneNumber" class="mppw-form-field__control" value="${householdMember.workPhoneNumber}" maxlength="50"> <label class="mppw-form-field__label" for="workPhoneNumber">${i18n.workPhoneLabel}:</label></div></div></div><div class="mpp-household--form-row w-50"><div class="mppw-form-field mppw-form-field__static-container"><select id="householdPositionId" name="householdPositionId" class="mppw-form-field__control" value="${householdMember.householdPositionId}"></select> <label class="mppw-form-field__label">${i18n.householdPositionLabel}</label></div></div><h3 class="mpp-household--form-header">${i18n.communicationPreferencesLabel}</h3><div class="mppw-form-field mppw-form-field__static-container mpp-household--checkbox-container"><div id="removeFromDirectoryCheck" name="removeFromDirectory" class="mppw-form-field__control mpp-household--checkbox"><label><label>${i18n.hideFromOnlineDirectoryLabel}</label> <input type="checkbox" name="removeFromDirectory" id="removeFromDirectory"/> <span class="mppw-checkbox"></span></label></div><label class="mppw-form-field__label" for="emailUnlistedCheck">${i18n.emailUnlistedLabel}</label></div><div class="mppw-form-field mppw-form-field__static-container mpp-household--checkbox-container"><div id="emailUnlistedCheck" name="emailUnlisted" class="mppw-form-field__control mpp-household--checkbox"><label><label>${i18n.emailUnlistedLabel}</label> <input type="checkbox" name="emailUnlisted" id="emailUnlisted"/> <span class="mppw-checkbox"></span></label></div><label class="mppw-form-field__label" for="emailUnlistedCheck">${i18n.emailUnlistedLabel}</label></div><div class="mppw-form-field mppw-form-field__static-container mpp-household--checkbox-container"><div id="mobileUnlistedCheck" name="mobilePhoneUnlisted" class="mppw-form-field__control mpp-household--checkbox"><label><label>${i18n.mobilePhoneUnlistedLabel}</label> <input type="checkbox" name="mobilePhoneUnlisted" id="mobilePhoneUnlisted"/> <span class="mppw-checkbox"></span></label></div><label class="mppw-form-field__label" for="mobileUnlistedCheck">${i18n.mobilePhoneUnlistedLabel}</label></div><div class="mppw-form-field mppw-form-field__static-container mpp-household--checkbox-container"><div id="doNotTextCheck" name="doNotText" class="mppw-form-field__control mpp-household--checkbox"><label><label>${i18n.doNotTextLabel}</label> <input type="checkbox" name="doNotText" id="doNotText"/> <span class="mppw-checkbox"></span></label></div><label class="mppw-form-field__label" for="doNotTextCheck">${i18n.doNotTextLabel}</label></div><div class="mppw-form-field mppw-form-field__static-container mpp-household--checkbox-container"><div id="bulkEmailOptOutCheck" name="bulkEmailOptOut" class="mppw-form-field__control mpp-household--checkbox"><label><label>${i18n.bulkEmailOptOutLabel}</label> <input type="checkbox" name="bulkEmailOptOut" id="bulkEmailOptOut"/> <span class="mppw-checkbox"></span></label></div><label class="mppw-form-field__label" for="bulkEmailOptOutCheck">${i18n.bulkEmailOptOutLabel}</label></div></div>` ;
      new FormManager(this._$householdMemberForm);
      this.BindImageUrlUploader();
      this.CommunicationPreferencesHandler(member.removeFromDirectory, member.emailUnlisted, member.mobilePhoneUnlisted, member.doNotText, member.bulkEmailOptOut);
      this.PopulateHouseholdMemberSelectOptions(member.genderId, member.maritalStatusId, member.householdPositionId, member.prefixId, member.suffixId);
    }
  }, {
    key: "HouseholdUnlistedHandler",
    value: function HouseholdUnlistedHandler(homePhoneUnlisted, homeAddressUnlisted) {
      this._root.querySelector('#homePhoneUnlisted').checked = homePhoneUnlisted;
      this._root.querySelector('#homeAddressUnlisted').checked = homeAddressUnlisted;
    }
  }, {
    key: "RepeatAnnuallyHandler",
    value: function RepeatAnnuallyHandler(alternativeAddressRepeatAnnually) {
      this._root.querySelector('#alternativeAddressRepeatAnnually').checked = alternativeAddressRepeatAnnually;
    }
  }, {
    key: "CommunicationPreferencesHandler",
    value: function CommunicationPreferencesHandler(removeFromDirectory, emailUnlisted, mobilePhoneUnlisted, doNotText, bulkEmailOptOut) {
      this._root.querySelector('#removeFromDirectory').checked = removeFromDirectory;
      this._root.querySelector('#emailUnlisted').checked = emailUnlisted;
      this._root.querySelector('#mobilePhoneUnlisted').checked = mobilePhoneUnlisted;
      this._root.querySelector('#doNotText').checked = doNotText;
      this._root.querySelector('#bulkEmailOptOut').checked = bulkEmailOptOut;
    }
  }, {
    key: "BindImageUrlUploader",
    value: function BindImageUrlUploader() {
      var _this8 = this;

      this._$imageUrl = this._root.querySelector("#imageUrl");
      this._$householdImagePreview = this._root.querySelector('#householdImagePreview');
      this._$fileTooLarge = this._root.querySelector("#fileTooLarge");
      this._$imageUrlLabel = this._root.querySelector('#imageUrlLabel');

      this._$imageUrl.addEventListener("change", function (event) {
        _this8._$fileTooLarge.style.display = "none";
        var file = _this8._$imageUrl.files[0];
        var MAX_FILE_SIZE = 10485760; // 10MB

        if (file.size >= MAX_FILE_SIZE) {
          _this8._$fileTooLarge.style.display = "block";
        } else {
          var reader = new FileReader();

          reader.onload = function (e) {
            _this8._$householdImagePreview.src = e.target.result;
            _this8._$householdImagePreview.className = "mpp-card--household-image";
            _this8._$imageUrlLabel.innerHTML = _this8.i18n.changePhotoLabel;
          };

          reader.readAsDataURL(event.target.files[0]);
        }
      });
    }
  }, {
    key: "PopulateHouseholdSelectOptions",
    value: function PopulateHouseholdSelectOptions(countryCode, alternativeCountryCode, congregationId, congregationName) {
      var _this9 = this;

      this._$addressCountry = this._root.querySelector('#country');
      this._$alternativeAddressCountry = this._root.querySelector('#alt_country');
      this._$congregationId = this._root.querySelector('#congregationId');

      this._lookupService.GetCountries().then(function (data) {
        _this9._localCountryCode = _this9._getLocalCountryCode(data);
        DropdownBuilder.BuildCountryDropdown(_this9._$addressCountry, data, _this9.i18n.countryLabel);
        DropdownBuilder.BuildCountryDropdown(_this9._$alternativeAddressCountry, data, _this9.i18n.countryLabel);
        _this9._$addressCountry.value = _this9.GetCountryCodeOrDefaultLocal(countryCode, data);
        _this9._$alternativeAddressCountry.value = _this9.GetCountryCodeOrDefaultLocal(alternativeCountryCode, data);
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this9._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });

      this._lookupService.GetCongregations(false).then(function (data) {
        if (!data.find(function (item) {
          return item.id === congregationId;
        })) {
          data.push({
            "id": congregationId,
            "value": congregationName,
            "name": congregationName
          });
        }

        DropdownBuilder.LoadDropdown(_this9._$congregationId, data, _this9.i18n.congregationLabel);
        _this9._$congregationId.value = congregationId;
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this9._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });
    }
  }, {
    key: "GetCountryCodeOrDefaultLocal",
    value: function GetCountryCodeOrDefaultLocal(countryCode, countyList) {
      var matches = countyList.filter(function (country) {
        return country.abbreviation == countryCode;
      });

      if (!!matches && matches.length > 0) {
        return countryCode;
      }

      return this._localCountryCode;
    }
  }, {
    key: "PopulateHouseholdMemberSelectOptions",
    value: function PopulateHouseholdMemberSelectOptions(gender, maritalStatus, householdPosition, prefix, suffix) {
      var _this10 = this;

      this._$genderId = this._root.querySelector('#genderId');
      this._$maritalStatusId = this._root.querySelector('#maritalStatusId');
      this._$householdPositionId = this._root.querySelector('#householdPositionId');
      this._$prefixId = this._root.querySelector('#prefixId');
      this._$suffixId = this._root.querySelector('#suffixId');

      this._lookupService.GetGenders().then(function (data) {
        DropdownBuilder.LoadDropdown(_this10._$genderId, data, _this10.i18n.genderLabel);
        _this10._$genderId.value = gender;
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this10._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });

      this._lookupService.GetMaritalStatuses().then(function (data) {
        DropdownBuilder.LoadDropdown(_this10._$maritalStatusId, data, _this10.i18n.maritalStatusLabel);
        _this10._$maritalStatusId.value = maritalStatus;
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this10._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });

      this._lookupService.GetHouseholdPositions().then(function (data) {
        DropdownBuilder.LoadDropdown(_this10._$householdPositionId, data, _this10.i18n.householdPositionLabel);
        _this10._$householdPositionId.value = householdPosition;
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this10._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });

      this._lookupService.GetPrefixes().then(function (data) {
        DropdownBuilder.LoadDropdown(_this10._$prefixId, data, _this10.i18n.prefixLabel);
        _this10._$prefixId.value = prefix;
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this10._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });

      this._lookupService.GetSuffixes().then(function (data) {
        DropdownBuilder.LoadDropdown(_this10._$suffixId, data, _this10.i18n.suffixLabel);
        _this10._$suffixId.value = suffix;
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this10._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "My Household",
        tag: "mpp-household",
        configurationItems: [{
          name: "Hide Add Household Member",
          attribute: "hideaddhouseholdmember",
          description: "Determines whether the 'Add Household Member' option is available. If available, Heads of Household will be able to add new Household Members (Default = false).",
          required: false,
          type: "bool"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["hideaddhouseholdmember"];
    }
  }]);

  return MppHousehold;
}(ComponentBase);
MppHousehold.registerComponent(MppHousehold.WidgetDetails.tag, MppHousehold);